import { EnvironmentRepository } from 'core/repositories/EnvironmentRepository';
import { Environment } from 'core/models/environment';

class DummyEnvironmentRepository implements EnvironmentRepository {
    async getEnvironments(): Promise<Environment[]> {
        return [
            {
                id: 'tier4env',
                name: 'Tier4',
            },
        ];
    }
}

export { DummyEnvironmentRepository as EnvironmentRepository };
